import React, { useEffect, useState, useContext, Fragment } from "react";
import SharedDataContext from "../../_helper/SharedData";
import {
    getUserRole,
    showAlert,
} from "../../Services/Shared.service";
import { Breadcrumbs, Btn, CommonModal, H6 } from "../../AbstractElements";
import { Row, Col, Card, CardBody, Container, Modal, ModalBody, Nav, NavItem, NavLink } from "reactstrap";
import { Plus } from "react-feather";
import {  getEmployeeListBySearch } from "../../Services/Employee.service";
import ExternalUserTable from "./ExternalUserTable";
import ExternalUserInput from "./ExternalUserInput";
import SearchTable from "../Common/Component/SearchTable";
import { Admin } from "../../Data/SideMenu/RouteMapping";
import { getExternalUserBySearch, getExternalUserList } from "../../Services/ExternalUser.service";
const ExternalUser = () => {
    const { cityData, globalCityField, setShowApiLoader } =
        useContext(SharedDataContext);
    const [tableData, setTableData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [pagination, setPagination] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [paginationTotalRows, setPaginationTotalRows] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const [searchData, setSearchData] = useState("");
    const [filterType, setFilterType] = useState("");
    const [filterData, setFilterData] = useState([]);
    const [editId, setEditId] = useState("")
    const userRole = getUserRole()

    const onChangePage = (page) => {
        console.log("page", page);
        setPagination(page - 1);
    };

    const onChangeRowsPerPage = (currentRowsPerPage) => {
        setRowsPerPage(currentRowsPerPage);
    };

    useEffect(() => {
        fetchTableData();
    }, [globalCityField.value, pagination, rowsPerPage]);

    const fetchTableData = () => {
        const serviceCityId = globalCityField.value?.id || "All";
        if (!searchData) {
            let obj = {
                serviceCityId: serviceCityId,
                page: pagination,
                size: rowsPerPage,
            };
            setLoader(true);
            getExternalUserList(obj)
                .then((result) => {
                    setPaginationTotalRows(result.data.count);
                    setTableData(result.data.thirdPartyUserList);
                    disableLoaders();
                })
                .catch((err) => {
                    disableLoaders();
                    showAlert("error", err.response?.data?.message
                        ? err.response.data.message : "Something went wrong");
                });
        } else if (searchData && filterType == "search") {
            let obj = {
                serviceCityId: serviceCityId,
                key: searchData,
                page: pagination,
                size: rowsPerPage,
            };
            setLoader(true);
            getExternalUserBySearch(obj)
                .then((result) => {
                    setPaginationTotalRows(result.data.count);
                    setTableData(result.data.thirdPartyUserList);
                    disableLoaders();
                })
                .catch((err) => {
                    disableLoaders();
                    showAlert("error", err.response?.data?.message
                        ? err.response.data.message : "Something went wrong");
                });
        }
    };
    const disableLoaders = () => {
        setLoader(false);
        // setShowApiLoader(false);
    };


    useEffect(() => {
        if (!searchData && filterType != "search") return;
        setPagination(0)
        fetchTableData();
    }, [searchData]);

    return (
        <Fragment>
            <Breadcrumbs
                parent="Configuration"
                subParent="Packages"
                mainTitle="Packages"
                //   span1={
                //     <FilterTable
                //       options={columns}
                //       setFilterData={setFilterData}
                //       filterData={filterData}
                //       setSearchData={setSearchData}
                //       setFilterType={setFilterType}
                //       statusData={bookingStatusData}
                //       bookingViaTypeData={bookingViaTypeData}
                //     />
                //   }
                span3={
                    <SearchTable
                        searchData={searchData}
                        setSearchData={setSearchData}
                        setFilterData={setFilterData}
                        setFilterType={setFilterType}
                        placeholder={"Search by Email"}
                    />
                }
                span2={
                    userRole.some(
                        (element) => element == Admin
                    ) ? <Btn attrBtn={{ style: { display: "flex", padding: "7px 14px", justifyContent: "center", alignItems: "center" }, onClick: (e) => setIsOpen(true) }}>
                        <Plus size={"18px"} style={{ marginRight: "5px" }} /> Add
                    </Btn> : null
                }
            />
            <Container fluid={true} className="datatables">
                <Row>
                  
                    <Col sm="12">
                        <Card>
                            <CardBody className="p-0">
                                <ExternalUserTable
                                    fetchTableData={fetchTableData}
                                    tableData={tableData}
                                    setShowApiLoader={setLoader}
                                    onChangePage={onChangePage}
                                    paginationPerPage={rowsPerPage}
                                    paginationTotalRows={paginationTotalRows}
                                    onChangeRowsPerPage={onChangeRowsPerPage}
                                    loader={loader}
                                    setEditId={setEditId}
                                    toggleCreateEmployeeModal={() => setIsOpen(!isOpen)}
                                    cityData={cityData}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <ExternalUserInput
                Large={isOpen}
                title={editId ? "Update External user" : "Create External user"}
                LargeModaltoggle={() => {
                    setEditId("")
                    setIsOpen(!isOpen)
                }}
                cityData={cityData}
                fetchTableData={fetchTableData}
                editId={editId} />
        </Fragment>
    );
};

export default  ExternalUser;
